class VideoComponant extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('video');
    this.controls = this.querySelector('.video-controls');
    this.playIcon = this.controls?.querySelector('.icon-play');
    this.pauseIcon = this.controls?.querySelector('.icon-pause');

    // Sound controls
    this.soundToggle = this.querySelector('.sound-toggle');
    this.soundOnIcon = this.soundToggle?.querySelector('.icon-sound-on');
    this.soundOffIcon = this.soundToggle?.querySelector('.icon-sound-off');

    this.autoplay = this.video?.hasAttribute('autoplay');

    // Bind handlers once
    this.onControlsClick = this.onControlsClick.bind(this);
    this.onSoundClick = this.onSoundClick.bind(this);
    this.onPlay = this.onPlay.bind(this);
    this.onPause = this.onPause.bind(this);
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    if (!this.video || !this.controls) return;

    // Default video setup
    this.video.muted = true;
    this.video.autoplay = this.autoplay;
    this.video.loop = true;
    this.video.playsInline = true;

    // Initial UI state
    this.updateIcons(!this.video.paused);
    this.updateSoundIcons(this.video.muted);

    // Events
    this.controls.addEventListener('click', this.onControlsClick);
    this.soundToggle?.addEventListener('click', this.onSoundClick);
    this.video.addEventListener('play', this.onPlay);
    this.video.addEventListener('pause', this.onPause);

    const maxscreen = window.matchMedia("(max-width: 1023px)");
    if (!maxscreen.matches) return;
    const pauseIcon = this.querySelector(".icon.icon-pause");
    const playIcon = this.querySelector(".icon.icon-play");

    if (!pauseIcon || !playIcon) return;

    let hideTimeout;

    const showPauseIcon = () => {
      pauseIcon.style.opacity = "1";
      pauseIcon.style.visibility = "visible";
    };

    const hidePauseIcon = () => {
      pauseIcon.style.opacity = "0";
      pauseIcon.style.visibility = "hidden";
    };
    this._observer = new MutationObserver(() => {
      clearTimeout(hideTimeout);

      const isPlaying = playIcon.classList.contains("hidden");

      if (isPlaying) {
        showPauseIcon();
        hideTimeout = setTimeout(() => {
          hidePauseIcon();
        }, 2000);
      } else {
        showPauseIcon();
      }
    });

    this._observer.observe(playIcon, {
      attributes: true,
      attributeFilter: ["class"],
    });
    this.maxscreen = maxscreen;
  }

  disconnectedCallback() {
    this.controls?.removeEventListener('click', this.onControlsClick);
    this.soundToggle?.removeEventListener('click', this.onSoundClick);
    this.video?.removeEventListener('play', this.onPlay);
    this.video?.removeEventListener('pause', this.onPause);

    this._initialized = false;
    if (this._observer) {
      this._observer.disconnect();
    }
  }

  onControlsClick(e) {
    // Prevent sound toggle from triggering play/pause
    if (e.target.closest('.sound-toggle')) return;
    this.togglePlay();
  }

  onSoundClick(e) {
    e.stopPropagation();
    this.toggleMute();
  }

  togglePlay() {

    if (this.video.paused) {
      this.video.play().catch(() => { });
    } else {
      this.video.pause();
    }
  }

  async toggleMute() {
    this.video.muted = !this.video.muted;
    this.updateSoundIcons(this.video.muted);

    // Required by some browsers to enable sound
    if (!this.video.muted && this.video.paused) {
      try {
        await this.video.play();
      } catch (err) {
        console.warn('Autoplay with sound blocked:', err);
      }
    }
  }

  updateIcons(isPlaying) {
    this.playIcon?.classList.toggle('hidden', isPlaying);
    this.pauseIcon?.classList.toggle('hidden', !isPlaying);
  }

  updateSoundIcons(isMuted) {
    this.soundOnIcon?.classList.toggle('hidden', isMuted);
    this.soundOffIcon?.classList.toggle('hidden', !isMuted);
  }

  onPlay() {
    this.updateIcons(true);
  }

  onPause() {
    this.updateIcons(false);
  }
}

// Correct custom element registration
if (!customElements.get('video-componant')) {
  customElements.define('video-componant', VideoComponant);
}

